import { useEffect, useRef, useState } from "react";

export function ScaledCanvas({ base, height, children, className = "" }) {
  const ref = useRef(null);
  const [scale, setScale] = useState(0);
  useEffect(() => {
    const el = ref.current;
    if (!el) return undefined;
    const ro = new ResizeObserver(([e]) => setScale(e.contentRect.width / base));
    ro.observe(el);
    return () => ro.disconnect();
  }, [base]);
  return (
    <div ref={ref} className={`relative w-full overflow-hidden ${className}`} style={height ? { height: height * scale } : { height: "100%" }}>
      {scale > 0 && (
        <div style={{ width: base, height: height || `${100 / scale}%`, transform: `scale(${scale})`, transformOrigin: "0 0" }} className="absolute left-0 top-0">
          {children}
        </div>
      )}
    </div>
  );
}

export function PhoneFrame({ children, className = "", screenClass = "", style }) {
  return (
    <div className={`phone-shell ${className}`} style={{ aspectRatio: "71.6 / 147.6", ...style }}>
      <span className="phone-btn" style={{ left: -2, top: "18%", height: "5%" }} />
      <span className="phone-btn" style={{ left: -2, top: "26%", height: "9%" }} />
      <span className="phone-btn" style={{ left: -2, top: "37%", height: "9%" }} />
      <span className="phone-btn" style={{ right: -2, top: "28%", height: "13%" }} />
      <div className={`phone-screen h-full w-full ${screenClass}`}>
        <div className="phone-island" />
        {children}
      </div>
    </div>
  );
}

export function LaptopFrame({ children, className = "" }) {
  return (
    <div className={className}>
      <div className="relative rounded-t-[18px] bg-[#1b1d21] p-[2.2%] pb-[1.6%] shadow-[0_0_0_1px_#3a3d44,0_40px_80px_-40px_rgba(0,0,0,.5)]">
        <div className="absolute left-1/2 top-[0.9%] h-[5px] w-[5px] -translate-x-1/2 rounded-full bg-[#33363d]" />
        <div className="relative aspect-[16/10] overflow-hidden rounded-[4px] bg-white">{children}</div>
      </div>
      <div className="relative mx-[-6%] h-[14px] rounded-b-[14px] bg-gradient-to-b from-[#d4d6db] to-[#9a9ca3] shadow-[0_18px_30px_-14px_rgba(0,0,0,.45)]">
        <div className="absolute left-1/2 top-0 h-[6px] w-[16%] -translate-x-1/2 rounded-b-[8px] bg-[#b4b6bc]" />
      </div>
    </div>
  );
}
